/* src/app/components/controls/content-controls/sem-quick-actions/sem-quick-actions.component.css */
:host-context(.SemHeroGridLayout) .box.has-configured-icon::after {
  display: none !important;
  content: none !important;
}
:host-context(.SemHeroGridLayout) .qa-info-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  box-shadow: none;
  font-size: 20px;
  line-height: 1;
  pointer-events: none;
}
:host-context(.SemHeroGridLayout) .action-description {
  max-width: calc(100% - 50px);
  margin: 6px 0 12px;
  color: #64748b;
  font-family: inherit !important;
  font-size: 12px !important;
  font-weight: 400;
  line-height: 1.35 !important;
  letter-spacing: 0.01em;
}
/*# sourceMappingURL=sem-quick-actions.component.css.map */
